const Wrapper = require('../Wrapper');
const CityInputWrapper = require('../CityInputWrapper');
const DatepickerWrapper = require('../DatepickerWrapper');
const SelectricWrapper = require('../SelectricWrapper');

class FilteringWrapper extends Wrapper {
    constructor(elementID) {
        super();
        this.element = document.getElementById(elementID);

        this.fType = new SelectricWrapper(document.getElementById('fType'));

        this.fromCity = new CityInputWrapper('fromCity');
        this.toCity = new CityInputWrapper('toCity');

        this.departureDate = new DatepickerWrapper('departureDate');
        this.arrivalDate = new DatepickerWrapper('arrivalDate');

        this.goodType = new SelectricWrapper(document.getElementById('want-to-send'));

        window.tt = this;

        this.model = {
            type: null,
        };

        this.initEvents();
        this.updateView();
    }

    get type() {
        return this.model.type;
    }

    set type(value) {
        this.updateModel({ type: value });
        this.updateView();
    }

    updateView() {
        switch (Number(this.type)) {
            case 1:
                this.goodType.updateOptionValue(0, 'first');

                this.goodType.show();
                this.goodType.$element.parent().parent().parent().show();

                $(this.fromCity.element).parent().show();
                $(this.toCity.element).parent().show();

                $(this.departureDate.element).parent().show();
                $(this.arrivalDate.element).parents('.form-floor').removeClass('single-element');
                $(this.arrivalDate.element).parent().show();
                $(this.arrivalDate.element).attr('placeholder', $(this.arrivalDate.element).attr('data-first-label'));

                $(this.element).find('ul + hr').show();

                break;
            case 2:
                this.goodType.updateOptionValue(0, 'second');

                this.goodType.show();
                this.goodType.$element.parent().parent().parent().show();

                $(this.fromCity.element).parent().show();
                $(this.toCity.element).parent().show();

                $(this.departureDate.element).parent().hide();

                $(this.arrivalDate.element).parent().show();
                $(this.arrivalDate.element).parents('.form-floor').addClass('single-element');
                $(this.arrivalDate.element).attr('placeholder', $(this.arrivalDate.element).attr('data-second-label'));

                $(this.element).find('ul + hr').show();

                break;
            default:
                this.goodType.hide();
                this.goodType.$element.parent().hide();

                $(this.fromCity.element).parent().hide();
                $(this.toCity.element).parent().hide();

                $(this.departureDate.element).parent().hide();
                $(this.arrivalDate.element).parent().hide();

                $(this.element).find('ul + hr').hide();

                break;
        }
    }

    initEvents() {
        this.fType.addListener(() => {
            this.type = this.fType.model.value;
        });

        this.goodType.addListener(() => {
            this.updateModel( { goodType: this.goodType.model.value })

            const selectElement = this.goodType.$element.get(0)

            const selectedOption = selectElement.querySelectorAll(`option`)[selectElement.selectedIndex]

            const iconKey = selectedOption.getAttribute('class').replace('icon-', '')

            const parentContainer = selectElement.parentElement.parentElement.parentElement;

            $(parentContainer.querySelector(`.luggage-icon`)).addClass('filtering-luggage-icon')

            $(parentContainer.querySelector(`.luggage-icon`)).show()
            $(parentContainer.querySelector(`i.fa`)).hide()

            parentContainer.querySelector(`.luggage-icon`).innerHTML = `<svg class="select-icon"><use xlink:href="#${iconKey}"></use></svg>`
        });

        this.fromCity.addListener(() => {
            this.updateModel({ fromCity: this.fromCity.model });
        });

        this.toCity.addListener(() => {
            this.updateModel({ toCity: this.toCity.model });
        });

        this.departureDate.addListener(() => {
            this.updateModel({ departureDate: this.departureDate.model.value });
        });

        this.arrivalDate.addListener(() => {
            this.updateModel({ arrivalDate: this.arrivalDate.model.value });
        });
    }
}

module.exports = FilteringWrapper;